import { Badge, ErrorMessage, Spinner } from "../../../../widgets";

import { FC } from "react";
import { FetchStatus } from "../../../../base/types";
import { FormContext } from "./FormContext";
import { IControlAttributes } from "../../../../base/models";
import { useFormProperties } from "./FormProperties";

export const DraftFormComponent: FC<IControlAttributes> = ({
    className, children, props
}) => {
    const { status, properties, error } = useFormProperties(props);

    switch (status) {
        case FetchStatus.Idle: return <></>
        case FetchStatus.Loading: return <Spinner show={true} />
        case FetchStatus.Error: return <ErrorMessage message={error} />
    }

    return (
        <div className={"inline-block position-relative"}>
            <Badge
                className={"position-absolute top-0 end-0 text-nowrap fs-9 rounded-0"}
                badgeStyle="primary">
                Form
            </Badge>
            <FormContext {...properties} className={className}>
                {children}
            </FormContext>
        </div>)
}